// jQuery(document).ready(function() {
//     if(!is_dev) {
//         return;
//     }
//     view_search_table(1);
// });
function add_custom_field(object, params) {
    var $ = jQuery.noConflict();

    if(typeof params == 'string') {
        params = JSON.parse(params);
    }


    $.squdeAjaxPopup({
        url: '/fields/add/'+object,
        data: params,
        onOpen: function (elm, popup) {

            elm.find('select.default_value_toggler').trigger('change');
            if(params && typeof params == 'object') {
                for(var key in params) {
                    if(typeof params[key] != 'function' && typeof params[key] != 'array' && typeof params[key] != 'object') {
                        elm.find('form').append('<input type="hidden" name="'+key+'" value="'+params[key]+'">');
                    }
                }
            }

            elm.find('form').ajaxFormSubmit(function(data){
                popup.close();
                $('body').append('<div class="i-am-loading"></div>');
                reload_location_if_needed();
            }.bind([elm,popup]), function(xhr, status, error) {
                $('body').doneLoading();
                squde_flash("Er ging iets mis bij het opslaan.","alert");
            }.bind([elm,popup]),function() {
                $('body').isLoading('dark');
            });
        }
    });
    return false;
}
function delete_custom_field(id, name) {
    var $ = jQuery.noConflict();
    name = decodeURI(name);

    confirm("Weet u zeker dat u \""+name+"\" wilt verwijderen?", function() {
        $('body').isLoading('dark');
        $.ajax({
            url: "/fields/delete",
            data: {id:id},
            type: "POST",
            success: function(data) {
                reload_location_if_needed();
            },
            error: function(e) {
                $('body').doneLoading();
                squde_flash("Er ging helaas iets mis.", "alert");
            }
        });
    });

    return false;
}
function view_custom_field(id) {
    var $ = jQuery.noConflict();

    $.squdeAjaxPopup({
        url: '/fields/view/'+id,
        onOpen: function(elm, popup) {
            elm.find('select.default_value_toggler').trigger('change');

            elm.find('form').ajaxFormSubmit(function(data){
                reload_location_if_needed();
            }.bind([elm,popup]), function(xhr, status, error) {
                $('body').doneLoading();
                squde_flash("Er ging iets mis bij het opslaan.", "alert");
            }.bind([elm,popup]),function() {
                $('body').isLoading('dark');
            });
        }
    });
    return false;
}

function toggle_default_custom_fields_value(sender) {
    var $ = jQuery.noConflict();

    var elm = $(sender);
    var w = elm.parents('.repeat-item');
    if(w.length == 0) {
        w = elm.parents('form');
    }

    var v = elm.val();

    w.find('.default-value-input').hide();
    w.find('.default-value-input').find(':input').attr('disabled','disabled');
    w.find('.default-value-input-for-'+v).show();
    w.find('.default-value-input-for-'+v).find(':input').removeAttr('disabled');

    var search_table_selector_wrapper = w.find('.search-table-selector');
    if(v == 'select') {
        search_table_selector_wrapper.show();
        if(search_table_selector_wrapper.is(':visible') || 1+1==2) {
            search_table_selector_wrapper.find('[data-search-table-selector]').searchTableSelector().change(function() {
                var sel = w.find('.default-value-input-for-select').find('select');
                var v = $(this).val();
                if(parseInt(v) > 0) {
                    $.get('/fields/search-tables/getOptions/'+v, function(data) {
                        sel.empty();
                        sel.append('<option value="-1">Geen</option>');
                        var default_option = sel.attr('data-current-value');
                        data.forEach(function(row) {
                            sel.append('<option value="'+row.id+'" '+(default_option != undefined && default_option == row.id ? 'selected' : null)+'>'+row.name+'</option>');
                        });
                    });
                }
            });
        }
    } else {
        search_table_selector_wrapper.hide();
    }
}
function add_search_table(afterAdd) {
    var $ = jQuery.noConflict();
    $.squdeAjaxPopup({
        url: '/fields/search-tables/add/',
        onOpen: function (elm, popup) {

            elm.find('form').ajaxFormSubmit(function(data){
                popup.close();
                if(afterAdd == undefined) {
                    reload_location_if_needed();
                } else {
                    $('body').doneLoading();
                    afterAdd(JSON.parse(data), elm, popup);
                }
            }.bind([elm,popup]), function(xhr, status, error) {
                $('body').doneLoading();
                squde_flash("Er ging iets mis bij het opslaan.","alert");
            }.bind([elm,popup]),function() {
                $('body').isLoading('dark');
            });
        }
    });
    return false;
}
function view_search_table(id, callback) {
    var $ = jQuery.noConflict();
    $.squdeAjaxPopup({
        url: '/fields/search-tables/view/'+id,
        onOpen: function (elm, popup) {

            elm.find('form').ajaxFormSubmit(function(data){
                popup.close();
                if(callback == undefined) {
                    reload_location_if_needed();
                } else {
                    $('body').doneLoading();
                    callback(JSON.parse(data), elm, popup);
                }
            }.bind([elm,popup]), function(xhr, status, error) {
                $('body').doneLoading();
                squde_flash("Er ging iets mis bij het opslaan.","alert");
            }.bind([elm,popup]),function() {
                $('body').isLoading('dark');
            });
        }
    });
    return false;
}